// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"96056ea8","453":"20debaff","775":"46dedda6","787":"cba141ba","795":"084a5c0f"}[chunkId] + ".chunk.js";
};